module.exports = __webpack_public_path__ + "static/media/epargn-policy-number.e884356c.png";